import React, { Fragment } from "react";
import { Avatar, IconButton } from '@material-ui/core';
import { CategoryTag, Corporation, Locale } from "../../core/api/model";
import CustomIcon from "../../core/custom-icon";
import { DashboardPanelListItem } from "../DashboardPanel";

export interface DashboardFavouritesCorporationsListItemProps {
  locale: Locale;
  corporation: Corporation;
  deleteFavourite: (elementId: number, categoryTag: CategoryTag) => void;
}

export const DashboardFavouritesCorporationsListItem = (props: DashboardFavouritesCorporationsListItemProps) => (
  <Fragment>
    <DashboardPanelListItem headline={props.corporation.corpName[props.locale]}
                            imageSlot={
                                <Avatar alt={props.corporation.corpLogo.altText}
                                        src={props.corporation.corpLogo.url}>
                                  <CustomIcon iconname='corporation'
                                              viewBox='0 0 16 16'
                                              fontSize='small'
                                  />
                                </Avatar>
                            }
                            actionsSlot={
                              <Fragment>
                                <IconButton aria-label=''
                                            color='primary'
                                            onClick={() => props.deleteFavourite(props.corporation.corpId, CategoryTag.Corporation)}
                                >
                                  <CustomIcon iconname='favourite' />
                                </IconButton>
                                <IconButton aria-label='mehr Informationen zum Unternehmen'
                                            target='_blank'
                                            component='a'
                                            color='primary'
                                            href={props.corporation.expoSiteLink[props.locale]}
                                >
                                  <CustomIcon iconname='arrowLong' />
                                </IconButton>
                              </Fragment>
                            } />
  </Fragment>
  );
